import { MedicalAppointmentConfirmation } from "../../../model/medical-appointment-cancel";
import { ReservationService } from "../../../services/reservation.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { Inject, OnInit, Component } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";


@Component({
  selector: 'app-medical-appointment-change-date-dialog',
  templateUrl: 'medical-appointment-change-date-dialog.component.html',
  styleUrls: ['./medical-appointment-change-date-dialog.component.css']
})
export class MedicalAppointmenChangeDateDialogComponent {

  loading: boolean;
  loadingAction: boolean;
  form: FormGroup;
  medicalAppointmentConfirmations: MedicalAppointmentConfirmation[];

  constructor(private reservationService: ReservationService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<any>
    , @Inject(MAT_DIALOG_DATA) public data: MedicalAppointmenChangeDateDialogComponent) {
      this.form = this.formBuilder.group({
       date: [new Date()]
      });
  }

  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close();
  }

  async save() {
    try {
      if (this.form.valid) {
        this.dialogRef.close(this.form.controls.date.value);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Turno fecha');
    } finally {
      this.loadingAction = false;
    }
  }

}
